export const GetProgramActivitiesSelector = ({
  programactivities: { GetProgramActivities }
}) => GetProgramActivities;
export const ProgramActivitiesSelector = ({
  programactivities: { ProgramActivities }
}) => ProgramActivities;
